var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C12 3.058 13.147 1 15.5 1 17.853 1 19 3.058 19 4.5c0 1.185-.498 2.52-1.028 3.616a20.749 20.749 0 0 1-1.413 2.453.98.98 0 0 1-.816.431H12a1 1 0 1 0 0 2h4.5a2.5 2.5 0 0 1 0 5H4.257a.98.98 0 0 1-.816-.431 20.753 20.753 0 0 1-1.413-2.453C1.498 14.02 1 12.686 1 11.5 1 10.058 2.147 8 4.5 8 6.853 8 8 10.058 8 11.5c0 1.382-.679 2.976-1.308 4.17-.271.516-.542.974-.764 1.33H16.5a1.5 1.5 0 0 0 0-3H12a2 2 0 1 1 0-4h2.072a21.115 21.115 0 0 1-.764-1.33C12.677 7.475 12 5.882 12 4.5zm3.263 5.5h.474c.263-.391.832-1.276 1.335-2.319C17.587 6.614 18 5.45 18 4.5c0-1.058-.853-2.5-2.5-2.5S13 3.442 13 4.5c0 1.118.571 2.525 1.193 3.705A20.247 20.247 0 0 0 15.263 10zM4.737 17a20.213 20.213 0 0 0 1.07-1.795C6.43 14.025 7 12.618 7 11.5 7 10.442 6.147 9 4.5 9S2 10.442 2 11.5c0 .95.413 2.114.928 3.181A19.75 19.75 0 0 0 4.263 17h.474zM14.5 4.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-11 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.5cb22acd89b5b6dd64a58b24d4884b72.svg";
export { ForwardRef as ReactComponent };